var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 1.5C9.34315 1.5 8 2.84315 8 4.5C8 6.15685 9.34315 7.5 11 7.5C12.6569 7.5 14 6.15685 14 4.5C14 2.84315 12.6569 1.5 11 1.5ZM7 4.5C7 2.29086 8.79086 0.5 11 0.5C13.2091 0.5 15 2.29086 15 4.5C15 6.70914 13.2091 8.5 11 8.5C8.79086 8.5 7 6.70914 7 4.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12C5.24864 12 1.5 15.4114 1.5 19.5C1.5 19.7761 1.27614 20 1 20C0.723858 20 0.5 19.7761 0.5 19.5C0.5 14.7516 4.81036 11 10 11C10.2761 11 10.5 11.2239 10.5 11.5C10.5 11.7761 10.2761 12 10 12ZM17.1464 12.6464C17.3417 12.4512 17.6583 12.4512 17.8536 12.6464L19.8536 14.6464C20.0488 14.8417 20.0488 15.1583 19.8536 15.3536L14.8536 20.3536C14.7598 20.4473 14.6326 20.5 14.5 20.5H12.5C12.2239 20.5 12 20.2761 12 20V18C12 17.8674 12.0527 17.7402 12.1464 17.6464L17.1464 12.6464ZM13 18.2071V19.5H14.2929L18.7929 15L17.5 13.7071L13 18.2071Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUserIcon);
export default __webpack_public_path__ + "static/media/EditUserIcon.f87be021544234997b097f1829413a0a.svg";
export { ForwardRef as ReactComponent };